/* eslint-disable react-hooks/exhaustive-deps */
import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { usePreventScroll } from "../hooks/usePreventScroll";
import { FadeInContent } from "./FadeInContent";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-align: left;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const MainButton = styled.button<{ }>`
  background: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 10px;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  width: 300px;
  cursor: pointer;

  &:hover {
    background: white;
    color: black;
  }

  &:active {
    transform: scale(0.98);
    background: white;
    color: black;
  }

  &:focus {
    outline: none;
     background: white;
    color: black;
  }


  @media (max-width: 748px) {
    font-size: 14px;
  }
`;

const Counter = styled.div`
  font-size: 14px;
  height: 18.5px;
  @media (max-width: 748px) {
    font-size: 12px;
  }
`;

export const ClickToStart = ({ enter }: { enter: () => void }) => {
  const [almost, setAlmost] = useState(false);
  const [done, setDone] = useState(false);
  const [showHeart, setShowHeart] = useState(false);

  const isVisited = localStorage.getItem("visited");
  const setVisited = () => {
    localStorage.setItem("visited", "true");
  };

  const [counter, setCounter] = useState();
  // usePreventScroll(true);

  const startAlmost = () => {
    setTimeout(() => {
      setAlmost(true);
    }, 2000);
    setTimeout(() => {
      setDone(true);
    }, 4000);
  };

  function counterClicked() {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "https://api.countapi.xyz/hit/jessecha222/awesomeclick");
    xhr.responseType = "json";
    xhr.onload = function () {
      // console.log(`This button has been clicked ${} times!`);
      setCounter(this.response.value);
    };
    xhr.send();
  }

  useEffect(()=>{
    counterClicked();
  }, [])

  const audio = new Audio("/sound/push.mp3");

  const buttonRef = useRef(null);
  const onClickAdd = () => {
    counterClicked();
    if (!isMobile) {
      audio.play();
    }
    if (buttonRef.current) {
      // @ts-ignore
      buttonRef.current.blur();
    }
  };


  return (
    <Container>
      <MainButton
        onClick={() => {
          if (done || isVisited) {
            setVisited();
            enter();
          } else if (showHeart) {
            onClickAdd();
          } else {
            setShowHeart(true);
            startAlmost();
          }
        }}
        ref={buttonRef}
      >
        {done
          ? "진짜 입장"
          : showHeart
          ? almost
            ? "거의 다 왔어요"
            : "사랑하는 만큼 하트를 눌러주세요"
          : "입장하기"}
      </MainButton>
      <Counter> {counter &&  `지금껏 모인 하트 : ${counter} ❤️`}</Counter>
    </Container>
  );
};
